<section class="container mx-auto py-5 flex flex-column gap-5 min-h-screen h-full">
  <div class="w-full flex flex-column gap-5">
    <div *ngIf="this.currentStep<11" class="progressBar">
      <span [class]="'m' + currentStep">
        <img src="../../../assets/icons/progress-cap.svg" alt="">
      </span>
      <small [class]="'s'+currentStep"></small>
    </div>
    <div class="logo_header">
      <a [routerLink]="['/home']">
        <img src="../../../assets/images/logo.svg" alt="">
      </a>
    </div>
  </div>

  <section class="flex-1">
    <form class="h-full" [formGroup]="profileForm" (ngSubmit)="continue()" validateOnSubmit>
      <div class="container_inner flex h-full w-full align-items-center justify-content-between">
        @if(this.currentStep==Step.step0)
        {
        <div class="w-full flex-column gap-3" formGroupName="name">
          <h1 class="font-medium text-2xl mb-4">Name</h1>
          <div class="w-full flex gap-3 align-items-start sm:flex-row flex-column">
            <div class="w-full flex flex-column gap-2 flex-1">
              <b class="text-left font-normal text-base">First Name</b>
              <input class="input"
                [ngClass]="{'ng-invalid ng-dirty' : profileForm.get('name.firstName').invalid && (submitted || profileForm.get('name.firstName').touched)}"
                type="text" pInputText formControlName="firstName" />
              <small class="ng-dirty ng-invalid text-red-500"
                *ngIf="profileForm.get('name.firstName').invalid && (submitted || profileForm.get('name.firstName').touched)">
                First Name
              </small>
            </div>
            <div class="w-full flex flex-column gap-2 flex-1">
              <b class="text-left font-normal text-base">Last Name</b>
              <input type="text" class="input" pInputText formControlName="lastName" />
            </div>
          </div>
        </div>
        }
        @if(this.currentStep==Step.step1)
        {
        <div class="w-full flex flex-column gap-4">
          <div class="w-full flex flex-column gap-2">
            <h1 class="font-medium text-2xl">What is your educational qualification?</h1>
            <p class="font-normal text-base">Select all applicable qualifications.</p>
          </div>
          <div class="flex flex-column gap-3" formGroupName="educataion">
            <div class="flex align-items-start gap-2 sm:flex-row flex-column">
              <div class="w-full sm:w-12rem flex-shrink-0">
                <p-checkbox formControlName="chkGraduationUndergraduate" label="Undergraduate" value="Undergraduate"
                  [binary]="true" [ngClass]="{'ng-invalid ng-dirty' : profileForm.get('educataion.chkGraduationUndergraduate').invalid
                  && (submitted || profileForm.get('educataion.chkGraduationUndergraduate').touched)}"
                  styleClass="chk1" labelStyleClass="labelchk1" class="w-full h-full relative"
                  (onChange)="onUnderGraduteCheckedChange($event)" />
                <small class="ng-dirty ng-invalid text-red-500"
                  *ngIf="profileForm.get('educataion.chkGraduationUndergraduate').value==false && (submitted || profileForm.get('educataion.chkGraduationUndergraduate').touched)">
                  Undergraduate is required
                </small>
              </div>
              <div class="w-full flex flex-column gap-2">
                <p-autoComplete formControlName="undergraduateUniversity" [suggestions]="institutes"
                  styleClass="autocom" (completeMethod)="filterInstitutes($event)"
                  *ngIf="profileForm.get('educataion.chkGraduationUndergraduate').value==true" [ngClass]="{'ng-invalid ng-dirty' : profileForm.get('educataion.undergraduateUniversity').invalid
                  && (submitted || profileForm.get('educataion.undergraduateUniversity').touched)}" optionValue="name"
                  optionLabel="name" class="w-full" placeholder="Name of University">
                </p-autoComplete>
                <small class="ng-dirty ng-invalid text-red-500"
                  *ngIf="profileForm.get('educataion.undergraduateUniversity').invalid && (submitted || profileForm.get('educataion.undergraduateUniversity').touched)">
                  Undergraduate is required
                </small>
              </div>
            </div>
            <div class="flex align-items-start gap-2 sm:flex-row flex-column">
              <div class="w-full sm:w-12rem flex-shrink-0">
                <p-checkbox formControlName="chkGraduationMasters" label="Masters" value="Masters" [binary]="true"
                  (onChange)="onMastersCheckedChange($event)" styleClass="chk1" labelStyleClass="labelchk1"
                  class="w-full h-full relative" />
              </div>
              <div class="w-full flex flex-column gap-2">
                <p-autoComplete formControlName="mastersUniversity" [suggestions]="institutes" styleClass="autocom"
                  (completeMethod)="filterInstitutes($event)"
                  *ngIf="profileForm.get('educataion.chkGraduationMasters').value==true" [ngClass]="{'ng-invalid ng-dirty' : profileForm.get('educataion.mastersUniversity').invalid
                                  && (submitted || profileForm.get('educataion.mastersUniversity').touched)}"
                  optionValue="name" optionLabel="name" class="w-full" placeholder="Name of University">
                </p-autoComplete>
                <small class="ng-dirty ng-invalid text-red-500"
                  *ngIf="profileForm.get('educataion.mastersUniversity').invalid && (submitted || profileForm.get('educataion.mastersUniversity').touched)">
                  Masters is required
                </small>
              </div>
            </div>
          </div>
        </div>
        }
        @if(this.currentStep==Step.step2)
        {
        <div class="w-full flex-column gap-3">
          <h1 class="font-medium text-2xl mb-4">When were you born?</h1>
          <!-- <div class="w-full">
            <p-inputNumber class="w-full" formControlName="bornOn" styleClass="input_num"
              [ngClass]="{'ng-invalid ng-dirty': submitted && !profileForm.get('bornOn')?.value}" formControlName="bornOn"
              [min]="18" suffix=" years" [max]="80"></p-inputNumber>
          </div> -->
          <div class="flex flex-column gap-2" formGroupName="bornOn">
            <label for="" class="text-base font-normal text-gray-500">Date of Birth</label>
            <div class="flex align-content-start gap-1 sm:gap-3">
              <div class="flex-1">
                <p-dropdown [options]="dobDays"
                  [ngClass]="{'ng-invalid ng-dirty' : submitted && ! profileForm.get('bornOn.dobDays').value}"
                  optionLabel="name" formControlName="dobDays" placeholder="Day" styleClass="selectBox1" appendTo="body"
                  class="w-full" />
                <small class="ng-dirty ng-invalid text-red-500" *ngIf="profileForm.get('bornOn.dobDays').invalid &&
                    (submitted || profileForm.get('bornOn.dobDays').touched)">
                  Day is required
                </small>
              </div>
              <div class="flex-1">
                <p-dropdown [options]="dobMonths"
                  [ngClass]="{'ng-invalid ng-dirty' : submitted && ! profileForm.get('bornOn.dobMonths').value}"
                  formControlName="dobMonths" optionLabel="name" placeholder="Month" styleClass="selectBox1"
                  appendTo="body" class="w-full" />
                <small class="ng-dirty ng-invalid text-red-500" *ngIf="profileForm.get('bornOn.dobMonths').invalid &&
                    (submitted || profileForm.get('bornOn.dobMonths').touched)">
                  Month is required
                </small>
              </div>
              <div class="flex-1">
                <p-dropdown [options]="dobYears" formControlName="dobYears"
                  [ngClass]="{'ng-invalid ng-dirty' : submitted && ! profileForm.get('bornOn.dobYears').value}"
                  optionLabel="name" placeholder="Year" styleClass="selectBox1" appendTo="body" class="w-full" />
                <small class="ng-dirty ng-invalid text-red-500" *ngIf="profileForm.get('bornOn.dobYears').invalid &&
                      (submitted || profileForm.get('bornOn.dobYears').touched)">
                  Year is required
                </small>
              </div>
            </div>
          </div>
          <small class="ng-dirty ng-invalid text-red-500 mt-2 block text-left" *ngIf="profileForm.get('bornOn').invalid &&
           (submitted || profileForm.get('bornOn').touched)">
            DOB is required
          </small>
        </div>
        }
        @if(this.currentStep==Step.step3)
        {
        <div class="w-full flex-column gap-3">
          <h1 class="font-medium text-2xl mb-4">Select Gender</h1>
          <div class="w-full">
            <p-dropdown [options]="genders" formControlName="gender"
              [ngClass]="{'ng-invalid ng-dirty' : submitted && !profileForm.value.gender}" optionLabel="name"
              placeholder="Select" styleClass="input-autocom" appendTo="body" class="w-full" />
          </div>
          <small class="ng-dirty ng-invalid text-red-500 mt-2 block text-left"
            *ngIf="profileForm.get('gender').invalid && (submitted || profileForm.get('gender').touched)">
            Select your gender
          </small>
        </div>
        }
        @if(this.currentStep==Step.step4)
        {
        <div class="w-full flex-column gap-3">
          <h1 class="font-medium text-2xl mb-4">Select Nationality </h1>
          <div class="w-full">
            <p-dropdown [options]="countries" styleClass="full-width" styleClass="input-autocom"
              [ngClass]="{'ng-invalid ng-dirty' : submitted && ! profileForm.get('nationality').value}"
              optionLabel="name" optionValue="countryCode" formControlName="nationality" [filter]="true" filterBy="name"
              [showClear]="true" appendTo="body" placeholder="Select Nationality">
              <ng-template pTemplate="selectedItem" let-selectedOption>
                <div class="flex align-items-center gap-2">
                  <div>{{ selectedOption.name }}</div>
                </div>
              </ng-template>
              <ng-template let-country pTemplate="item">
                <div class="flex align-items-center gap-2">
                  <div>{{ country.name }}</div>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
          <small class="ng-dirty ng-invalid text-red-500 mt-2 block text-left"
            *ngIf="profileForm.get('nationality').invalid && (submitted || profileForm.get('nationality').touched)">
            Select your Nationality
          </small>
        </div>
        }
        @if(this.currentStep==Step.step5)
        {
        <div class="w-full flex flex-column gap-4">
          <div class="w-full flex flex-column gap-2">
            <h1 class="font-medium text-2xl">Are you currently working? </h1>
            <p class="font-normal text-base">If yes, please list your organisation and designation below.</p>
          </div>
          <div class="w-full flex-column md:flex-row flex align-content-start gap-3">

            <div class="flex-1 flex flex-column gap-2">
              <b class="w-full text-left font-medium">Company Name</b>
              <p-autoComplete formControlName="companySchool" [suggestions]="places"
                [ngClass]="{'ng-invalid ng-dirty': submitted && !profileForm.get('companySchool')?.value}"
                class="w-full" (completeMethod)="filterPlaces($event)" styleClass="autocom" optionValue="name"
                optionLabel="name">
              </p-autoComplete>
              <small class="ng-dirty ng-invalid text-red-500 block text-left"
                *ngIf="profileForm.get('companySchool')?.invalid && (submitted || profileForm.get('companySchool')?.touched)">
                Company / School is required
              </small>
            </div>

            <div class="flex-1 flex flex-column gap-2">
              <b class="w-full text-left font-medium">Designation</b>
              <input type="text" class="input" pInputText formControlName="designation" />
            </div>
          </div>
        </div>
        }
        @if (this.currentStep==Step.step6) {
        <div class="w-full flex-column gap-3">
          <h1 class="font-medium text-2xl mb-4">Your Professional Experience </h1>
          <div class="w-full flex gap-3 align-items-start sm:flex-row flex-column" formGroupName="experience">
            <div class="w-full flex flex-column gap-2 flex-1">
              <b class="text-left font-normal text-base">Years</b>
              <p-dropdown [options]="years" formControlName="years"
                [ngClass]="{'ng-invalid ng-dirty' : submitted && ! profileForm.get('experience.years').value}"
                optionLabel="name" placeholder="Year" styleClass="selectBox1" appendTo="body" class="w-full" />
              <small class="ng-dirty ng-invalid text-red-500 mt-2 block text-left" *ngIf="profileForm.get('experience.years').invalid &&
              (submitted || profileForm.get('experience.years').touched)">
                Years is required
              </small>
            </div>
            <div class="w-full flex flex-column gap-2 flex-1">
              <b class="text-left font-normal text-base">Months</b>
              <p-dropdown [options]="months" formControlName="months"
                [ngClass]="{'ng-invalid ng-dirty' : submitted && ! profileForm.get('experience.months').value}"
                optionLabel="name" placeholder="Month" styleClass="selectBox1" appendTo="body" class="w-full" />
              <small class="ng-dirty ng-invalid text-red-500 mt-2 block text-left" *ngIf="profileForm.get('experience.months').invalid &&
              (submitted || profileForm.get('experience.months').touched)">
                Months is required
              </small>
            </div>
          </div>
        </div>
        }

        @if(this.currentStep==Step.step7)
        {
        <div class="w-full flex-column gap-3">
          <h1 class="font-medium text-2xl mb-4">Why do you want to be a mentor?</h1>
          <div class="w-full flex gap-2 flex-column">
            <textarea formControlName="whydoYouWantToBeMentor" class="w-full" rows="5" cols="30" pInputTextarea>
            </textarea>

          </div>
          <small class="ng-dirty ng-invalid text-red-500 mt-2 block text-left" *ngIf="profileForm.get('whydoYouWantToBeMentor').invalid &&
          (submitted || profileForm.get('whydoYouWantToBeMentor').touched)">
            Why do you want to be a mentor is required
          </small>
        </div>
        }

        @if(this.currentStep == Step.step8) {
        <div class="w-full flex flex-column gap-4">
          <!-- <div class="w-full flex flex-column gap-2">
            <h1 class="font-medium text-2xl">What services do you specialize in?</h1>
            <p class="font-normal text-base">Select all applicable options.</p>
          </div> -->
          <div class="section-header">
            <h2 class="section-header__title">Services Selection</h2>
            <p class="section-header__hint">What services do you specialize in? Select all applicable options.</p>
          </div>

          <div class="w-full flex flex-column md:flex-row md:flex-wrap">
            <div *ngFor="let option of serviceOptions" class="md:col-6 col-12 flex align-items-center relative">
              <p-checkbox formControlName="servicesSpecialization" [value]="option.key" [label]="option.name"
                labelStyleClass="labelchk1" styleClass="chk1" class="w-full h-full relative" />
            </div>
            <div class="md:col-6 col-12 flex align-items-center relative">
              <p-checkbox value="Other - Please specify" label="Other - Please specify" labelStyleClass="labelchk1"
                styleClass="chk1" class="w-full h-full relative" (onChange)="onOtherServiceChange($event)" />
            </div>
          </div>
          <div *ngIf="showOtherServiceInput" class="w-full flex flex-column gap-2 flex-1">
            <b class="text-left font-normal text-base">Please enter your specialization:</b>
            <input class="input" type="text" pInputText formControlName="otherServiceSpecControl" />
            <small class="ng-dirty ng-invalid text-red-500"
              *ngIf="profileForm.get('otherServiceSpecControl').invalid && (submitted || profileForm.get('otherServiceSpecControl').touched)">
              Other Specialization is required
            </small>
          </div>
          <small class="text-red-500 mt-2 block text-left"
            *ngIf="profileForm.errors?.['servicesSpecializationRequired'] && (submitted || profileForm.touched)">
            What services do you specialize in is required
          </small>

          <hr class="w-full my-4" />

          <!-- <div class="w-full flex flex-column gap-2">
            <h1 class="font-medium text-2xl">What subjects do you specialize in?</h1>
            <p class="font-normal text-base">Select all applicable options.</p>
          </div> -->

          <div class="section-header">
            <h2 class="section-header__title">Subject Specialization</h2>
            <p class="section-header__hint">What subjects do you specialize in? Select all applicable options.</p>
          </div>

          <div class="w-full flex flex-column md:flex-row md:flex-wrap">
            <div *ngFor="let option of subjectOptions" class="md:col-6 col-12 flex align-items-center relative">
              <p-checkbox formControlName="subjectSpecialization" [value]="option.key" [label]="option.name"
                labelStyleClass="labelchk1" styleClass="chk1" class="w-full h-full relative" />
            </div>
            <div class="md:col-6 col-12 flex align-items-center relative">
              <p-checkbox value="Other - Please specify" label="Other - Please specify" labelStyleClass="labelchk1"
                styleClass="chk1" class="w-full h-full relative" (onChange)="onOtherSubjectChange($event)" />
            </div>
          </div>
          <div *ngIf="showOtherSubjectInput" class="w-full flex flex-column gap-2 flex-1">
            <b class="text-left font-normal text-base">Please enter your subject:</b>
            <input class="input" type="text" pInputText formControlName="otherSubjectSpecControl" />
            <small class="ng-dirty ng-invalid text-red-500"
              *ngIf="profileForm.get('otherSubjectSpecControl').invalid && (submitted || profileForm.get('otherSubjectSpecControl').touched)">
              Other Subject is required
            </small>
          </div>
          <small class="text-red-500 mt-2 block text-left"
            *ngIf="profileForm.errors?.['subjectSpecializationRequired'] && (submitted || profileForm.touched)">
            What subjects do you specialize in is required
          </small>
        </div>
        }

        @if(this.currentStep==Step.step9)
        {
        <div class="w-full flex-column gap-3">
          <h1 class="font-medium text-2xl mb-4">Upload resume</h1>
          <div class="w-full text-center">
            <app-file-uploader class="flex justify-content-center" [fileMode]="'single'" [fileSize]="50"
              [fileTypes]="'.pdf'" (filesSelected)="onFileSelection($event)" (filesRemoved)="onFileRemoved($event)"
              (validationError)="onFileHandlingError($event)"></app-file-uploader>
          </div>
          <small class="ng-dirty ng-invalid text-red-500 mt-2 block text-center" *ngIf="submitted && !file">
            Resume is required!
          </small>
        </div>
        }

        <!-- <div class="w-full flex hidden flex-column gap-3">
          <h1 class="font-medium text-2xl">Your Gradpilots page link</h1>
          <div class="w-full flex-column sm:flex-row flex gap-3 align-items-center">
            <input type="text" pInputText class="max-w-20rem" style="width: 100%;
            text-align: left;
            height: 56px;
            border: 1px solid #C0C0C0;
            padding: 8px 16px;
            border-radius: 12px;"/>
            <b class="font-medium">&#x40;gradpilots.com</b>
          </div>
        </div> -->

        @if(this.currentStep>Step.step9) {
        <div class="flex flex-column gap-6 align-items-center">
          <div class="flex align-items-center justify-content-center">
            <a [routerLink]="['/home']">
              <img src="../../../assets/icons/progress-cap.svg" alt="" class="w-10rem">
            </a>
          </div>
          <h1 class="text-4xl text-center">Thank you for your submission. Our team will be in touch with you shortly!
            <br>
            <br>
            <a [routerLink]="['/home']" class="underline mt-4">Go To Website</a>
          </h1>
        </div>
        }
      </div>
    </form>
  </section>

  <div *ngIf="this.currentStep<10"
    [ngClass]="{'justify-content-between': this.currentStep>0, 'justify-content-end': this.currentStep<1}"
    class="flex-column gap-3 sm:flex-row flex align-content-center justify-content-between py-5 border-top-1 border-gray-200">
    <p-button label="Back" *ngIf="this.currentStep>0" class="md:w-auto w-full" icon="pi pi-arrow-left" [outlined]="true"
      (onClick)="back()" styleClass="submitBtn-outline" />
    <p-button label="CONTINUE" (onClick)="continue()" [loading]="this.loading" class="md:w-auto w-full"
      styleClass="submitBtn" />
  </div>
</section>